import React, { useState, useEffect, useCallback } from 'react';



const DynamicProcessor = () => {

  
  const logic = {
    "when": [
      {
        "variable": "j",
        "operator": "==",
        "value": "1"
      }
    ],
    "when_and_or_operator": "AND",
    "then": [
      {
        "action": "jump_to_page",
        "value": "1"
      }
    ]
  };

  const [state, setState] = useState({ j: 1 });

  const evaluateCondition = (condition) => {
    const { variable, operator, value } = condition;
    switch (operator) {
      case '==':
        return state[variable] == value;
      case '!=':
        return state[variable] != value;
      default:
        return false;
    }
  };

  const executeAction = (action) => {
    const { action: type, value, variable, operator, blocks, element } = action;
    switch (type) {
      case 'calculate':
        if (operator === 'assign') {
          setState(prev => ({ ...prev, [variable]: value }));
        }
        break;
      case 'show_blocks':
      case 'hide_blocks':
        //console.log(`${type} these blocks: ${blocks}`);
        break;
      case 'disable_item':
        //console.log(`Disabling item: ${element}`);
        break;
      case 'jump_to_page':
        //console.log(`Jumping to page: ${value}`);
        break;
      default:
        //console.log('Action not recognized');
    }
  };

  const processLogic = () => {
    const { when, when_and_or_operator, then } = logic;
    let conditionResult = when_and_or_operator === 'AND' ? true : false;

    for (const condition of when) {
      const result = evaluateCondition(condition);
      if (when_and_or_operator === 'AND') {
        conditionResult = conditionResult && result;
      } else {
        conditionResult = conditionResult || result;
      }
    }

    if (conditionResult) {
      then.forEach(action => executeAction(action));
    }
  };

  return (
    <div>
      <button onClick={processLogic}>Evaluate</button>
      <pre>{JSON.stringify(state, null, 2)}</pre>
    </div>
  );
};

export default DynamicProcessor;
